module.exports = __webpack_public_path__ + "static/img/p1.8fb0baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p1.png
// module id = gdVr
// module chunks = 0